import apiClient from "../../admin/api/apiClient";

const API_PATH = process.env.REACT_APP_API_PATH;

export interface Blog {
  tags: string;
  blogID: number;
  blogTitle: string;
  blogSlug: string;
  shortDescription: string;
  blogContent: string;
  blogImage: string;  
  authorName: string;
  publishDate: string;
  status: string;
}

export interface ApiResponse<T> {
  statusCode: number;
  isSuccess: boolean;
  message: string;
  data?: T;
  dataList?: T[];
}

const API_URL = "/Blogs";

export const blogService = {
  getAll: async (): Promise<Blog[]> => {
    debugger
    const response =
      await apiClient.get<
        ApiResponse<Blog>
      >(`${API_URL}`);

    const result = response.data;
    console.log(result,"DataCheck")
    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    return (result.dataList || []).map((b: any) => ({
      ...b,

      // Convert relative path to full URL
      blogImage: b.blogImage
        ? `${API_PATH}/uploads/${b.blogImage}`
        : "",

      // Only published blogs
      status: b.status
    }));
  }
};